var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"35f23463714e80d41867798f25efdc435bde1580"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["propup@propup-gmbh"]={id:"35f23463714e80d41867798f25efdc435bde1580"};
      